import esES from '@arco-design/web-react/es/locale/es-ES';
import enUS from '@arco-design/web-react/es/locale/en-US';

const arcoLocales = {
  es: esES,
  en: enUS,
};

export function getArcoLocale(lang) {
  return arcoLocales[lang] || esES;
}
